import {Grid as GridChakra, GridProps} from '@chakra-ui/react'
import {
  Container as ContainerGS,
  ContainerProps,
  Row as RowGS,
  RowProps,
  Col as ColGS,
  ColProps,
  Hidden as HiddenGS,
  HiddenProps,
  Visible as VisibleGS,
  VisibleProps,
} from 'react-grid-system'
//https://sealninja.github.io/react-grid-system/

export const ContainerGrid = (props: ContainerProps & any) => {
  return <ContainerGS {...props}></ContainerGS>
}

export const Row = (props: RowProps & any) => {
  return <RowGS {...props}></RowGS>
}
type CustomColProps = ColProps &
  any & {
    grid: {
      xs: Number
      sm: Number
      md: Number
      lg: Number
      xl: Number
      xxl: Number
    }
  }
export const Col = ({...rest}: CustomColProps) => {
  return (
    <ColGS
      xs={rest?.grid?.xs}
      sm={rest?.grid?.sm}
      md={rest?.grid?.md}
      lg={rest?.grid?.lg}
      xl={rest?.grid?.xl}
      xxl={rest?.grid?.xxl}
      {...rest}
    ></ColGS>
  )
}
export const Hidden = (props: HiddenProps & any) => {
  return <HiddenGS {...props}></HiddenGS>
}
export const Visible = (props: VisibleProps & any) => {
  return <VisibleGS {...props}></VisibleGS>
}
export const Grid = (props: GridProps & any) => {
  return <GridChakra {...props}></GridChakra>
}
export default RowGS
